function autoPlay(slider, options) {
    // Avbryt om autoplay är avstängt
    if (slider.getAttribute('data-auto-play') !== 'true') return

    const slides = slider.querySelectorAll('.slide')
    const buttons = slider.querySelectorAll('.slide-button')
    const totalSlides = slides.length

    // Hitta den aktiva sliden
    const currentSlide = slider.querySelector('.slide.active')
    if (!currentSlide) return

    const currentIndex = parseInt(currentSlide.getAttribute('data-slide_index').split('_')[1])
    let progressBar = buttons[currentIndex]?.querySelector('.progress-bar')

    // Starta progressbar för aktuell slide
    startProgressBar(progressBar, options.autoPlayInterval)

    // Första gången vi kör autoplay, vänta en cykel innan vi startar
    if (options.firstTime) {
        options.firstTime = false
        return setTimeout(() => autoPlay(slider, options), options.autoPlayInterval)
    }

    // Återställ progressbar när sliden byts
    setTimeout(() => resetProgressBar(progressBar), options.autoPlayInterval)

    // Räkna ut nästa slide (loopar om vid sista)
    const nextIndex = (currentIndex + 1) % totalSlides
    setActiveSlide(slider, currentIndex, nextIndex)

    // Starta autoplay för nästa slide
    setTimeout(() => autoPlay(slider, options), options.autoPlayInterval)
}

function startProgressBar(progressBar, duration) {
    if (progressBar) {
        progressBar.style.transition = `width ${duration}ms linear`
        progressBar.style.width = '100%'
    }
}

// Återställ progressbar när slide byts
function resetProgressBar(progressBar) {
    if (progressBar) progressBar.style.width = '0'
}

function setActiveSlide(slider, currentIndex, nextIndex) {
    const slides = slider.querySelectorAll('.slide')
    const buttons = slider.querySelectorAll('.slide-button')

    // Ta bort aktiv status från nuvarande slide och knapp
    slides[currentIndex].classList.remove('active')
    buttons[currentIndex].classList.remove('active')

    // Lägg till aktiv status på nästa slide och knapp
    slides[nextIndex].classList.add('active')
    buttons[nextIndex].classList.add('active')

    // Skrolla knappcontainern så att aktiv knapp är synlig
    const buttonContainer = buttons[nextIndex].closest('.overflow-auto')
    if (buttonContainer) {
        buttonContainer.scrollTo({
            top: buttons[nextIndex].offsetTop - buttonContainer.offsetTop,
            behavior: 'smooth',
        })
    }

    // Starta progressbar för den nya aktiva knappen
    startProgressBar(buttons[nextIndex]?.querySelector('.progress-bar'), getAutoPlayInterval(slider))
}

function getAutoPlayInterval(slider) {
    // Hämta autoplay-intervallet från attributet eller använd standard 3000ms
    return parseInt(slider.getAttribute('data-auto-play-interval'), 10) || 3000
}

document.addEventListener('DOMContentLoaded', () => {
    // Starta autoplay för varje slider på sidan
    document.querySelectorAll('.vertical-slider').forEach((slider) => {
        const options = {
            autoPlayInterval: getAutoPlayInterval(slider),
            firstTime: true,
        }
        autoPlay(slider, options)
    })
})

document.addEventListener('click', (e) => {
    if (e.target.classList.contains('slide-button')) {
        const button = e.target
        const slider = button.closest('.vertical-slider')
        const buttonIndex = button.getAttribute('data-button_index')
        const slide = slider.querySelector(`[data-slide_index="${buttonIndex}"]`)

        if (!slide) return

        // Dölj alla progress bars när man klickar på en knapp
        slider.querySelectorAll('.progress-bar').forEach((progressBar) => progressBar.classList.add('hidden'))

        // Ta bort aktiv status från alla slides och knappar
        slider.querySelectorAll('.slide').forEach((s) => s.classList.remove('active'))
        slider.querySelectorAll('.slide-button').forEach((btn) => btn.classList.remove('active'))

        // Sätt vald slide och knapp som aktiv
        slide.classList.add('active')
        button.classList.add('active')

        // Stäng av autoplay vid klick
        slider.setAttribute('data-auto-play', 'false')
    }
})
